__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "parent";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "4.13.1", () => (__webpack_require__.e(123).then(() => (() => (__webpack_require__(6123))))));
			register("@azure/msal-react", "3.0.12", () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(298)]).then(() => (() => (__webpack_require__(6810))))));
			register("@keiko-app/react-google-analytics", "1.0.0", () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(4496))))));
			register("@microsoft/feature-management", "2.1.0", () => (Promise.all([__webpack_require__.e(452), __webpack_require__.e(764)]).then(() => (() => (__webpack_require__(452))))));
			register("@scts-ui/component-library", "0.0.260", () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(527), __webpack_require__.e(228), __webpack_require__.e(420)]).then(() => (() => (__webpack_require__(9651))))));
			register("@tanstack/react-query", "5.81.5", () => (Promise.all([__webpack_require__.e(205), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(1205))))));
			register("axios", "1.10.0", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))));
			register("linq", "4.0.3", () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(4817))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-helmet", "6.1.0", () => (__webpack_require__.e(154).then(() => (() => (__webpack_require__(8154))))));
			register("react-router", "6.30.1", () => (() => (__webpack_require__(913))), 1);
			register("react-router", "7.6.2", () => (() => (__webpack_require__(7672))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			initExternal(9411);
			initExternal(7419);
			initExternal(5573);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};